import { Document, Page, Text, View } from '@react-pdf/renderer';
import { formatDate } from '../../../utils/helpers';
import { leaveApplicationPDFStyles } from './styles';
import { Signature } from './Signature';
import { LeaveApplicationTemplateBaseProps } from './types';
import {
  getFormattedDate,
  getGenderWords,
  getLeaveTypePdfHeader,
  getRomanianDateOrPeriodText,
  getRomanianLeaveDaysText,
} from './utils';

export const LeaveApplicationTemplateBase = ({
  name,
  position,
  days,
  period,
  date,
  substitute,
  employeeSignature,
  managerSignature,
  gender,
  splitText,
  yearQualifier,
  requestType,
  unpaidLeaveReason,
}: LeaveApplicationTemplateBaseProps) => {
  const genderWords = getGenderWords(gender);
  const displayName = name || '________________________';
  const displayPosition = position || '_________________';
  const displayDays = days || '____';
  const displayPeriod = period || '______________';
  const displayDate = date ? formatDate(date) : getFormattedDate();
  const displaySubstitute = substitute || '________';

  return (
    <Document>
      <Page size="A4" style={leaveApplicationPDFStyles.page}>
        <Text style={leaveApplicationPDFStyles.header}>{getLeaveTypePdfHeader(requestType, unpaidLeaveReason)}</Text>
        <View style={leaveApplicationPDFStyles.mainText}>
          <Text style={leaveApplicationPDFStyles.tab}>
            {genderWords.subject}, {displayName}, {genderWords.employee}{' '}
             Technology Reply Srl, în funcția de
          </Text>
          <Text>
             {displayPosition}, vă rog să-mi aprobați efectuarea unui număr de{' '}
             {displayDays}{' '}
             {getRomanianLeaveDaysText(displayDays, requestType, unpaidLeaveReason)}
             {yearQualifier} în
             {getRomanianDateOrPeriodText(displayDays)} {displayPeriod}.
          </Text>
          {splitText ? <Text>{splitText}</Text> : null}
        </View>
        <View style={leaveApplicationPDFStyles.mainText}>
          <Text style={leaveApplicationPDFStyles.tab}>
            {genderWords.replace} {displaySubstitute}
          </Text>
        </View>
        <View style={leaveApplicationPDFStyles.dateAndEmployeeSignatureSection}>
          <Text style={leaveApplicationPDFStyles.date}>Data {displayDate}</Text>
          <View style={leaveApplicationPDFStyles.signature}>
            <Text>{genderWords.signature}</Text>
            <Signature value={employeeSignature} />
          </View>
        </View>
        <View style={leaveApplicationPDFStyles.managerSignatureSection}>
          <View style={leaveApplicationPDFStyles.signature}>
            <Text>Manager,</Text>
            <Signature value={managerSignature} />
          </View>
        </View>
      </Page>
    </Document>
  );
};
